export default class SingleRecipePage {
  constructor() {
    console.info('SingleRecipePage.constructor()');

    this.checkIngredients();
  }

  checkIngredients() {
    console.info('SingleRecipePage.checkIngredients()');

    $('.instructions__item').each(function () {
      if ($(this).has('em').length == true) {
        $(this).addClass('testimonial');
        $(this).removeAttr('itemprop');
      }
    });
  }
}
